/* global  scrollLock */
import vars from '../helpers';

const menuLink = vars.menu.querySelectorAll('.menu__link');
let tlmenu = gsap.timeline();
let menuAnim = true;

const menuOpen = () => {
	tlmenu.from(vars.menu, {
		onStart() {
			menuAnim = false;
			vars.burger.classList.add('is-menu');
			vars.menu.classList.remove('is-hidden');
			scrollLock.disablePageScroll();
		},
		onComplete() {
			menuAnim = true;
		},
		duration: vars.duration,
		opacity: 0,
		ease: 'Power1.easeOut',
		clearProps: 'all',
	});

	menuLink.forEach((link) => {
		tlmenu.from(link, {
			duration: vars.duration / 2,
			opacity: 0,
			y: '100%',
			ease: 'Power1.easeOut',
			clearProps: 'all',
		}, '-=30%');
	});

	gsap.matchMedia().add('(max-width: 1024px)', () => {
		tlmenu.to(vars.social, {
			onStart() {
				vars.social.classList.remove('is-hidden');
			},
			duration: vars.duration / 2,
			opacity: 1,
			ease: 'Power1.easeOut',
		}, '-=30%');
	});
};

const menuClose = () => {
	tlmenu.to(vars.menu, {
		onStart() {
			menuAnim = false;
			vars.burger.classList.remove('is-menu');
		},
		onComplete() {
			menuAnim = true;
			vars.menu.classList.add('is-hidden');
			scrollLock.enablePageScroll();
		},
		duration: vars.duration,
		opacity: 0,
		ease: 'Power1.easeOut',
		clearProps: 'all',
	});

	gsap.matchMedia().add('(max-width: 1024px)', () => {
		tlmenu.to(vars.social, {
			onComplete() {
				vars.social.classList.add('is-hidden');
			},
			duration: vars.duration / 2,
			opacity: 0,
			ease: 'Power1.easeOut',
		}, '<');
	});
};

const menuInit = () => {
	vars.burger.addEventListener('click', () => {
		if (!menuAnim) {
			return;
		}

		if (vars.burger.classList.contains('is-menu')) {
			menuClose();
		} else {
			menuOpen();
		}
	});
};

export {menuInit};
